import { PropsWithChildren } from 'react';

import { useSentry } from './useSentry';

export const InitSentry: React.FC<PropsWithChildren> = ({ children }) => {
    useSentry();
    return <>{children}</>;
};
